export default "import.meta.ROLLUP_FILE_URL_e5e777e9"